import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useApp } from '../data/ColisContext';
import { BRAND } from '../data/constants';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { register } = useApp();

  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== password2) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }
    try {
      await register(email, password, tel);
      navigate('/login', {
        replace: true,
        state: { flash: 'Inscription réussie. Connecte-toi maintenant.' },
      });
    } catch (err) {
      setError(err?.message || 'Erreur lors de la création du compte');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'DM Sans', sans-serif", padding: '40px 20px' }}>
      <div style={{ maxWidth: 520, margin: '0 auto' }}>
        <div style={{ background: 'white', borderRadius: 20, padding: 28, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          <div style={{ fontSize: 22, fontWeight: 900, color: '#1e293b', marginBottom: 6 }}>Créer un compte</div>
          <div style={{ fontSize: 14, color: '#64748b', marginBottom: 20 }}>Inscris-toi pour déposer des colis et retrouver ton historique.</div>

          {error && (
            <div style={{ background: '#FEE2E2', color: '#B91C1C', padding: '10px 12px', borderRadius: 12, fontWeight: 700, fontSize: 13, marginBottom: 14 }}>
              {error}
            </div>
          )}

          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <label style={{ fontWeight: 700, fontSize: 13, color: '#334155' }}>
              Email
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <label style={{ fontWeight: 700, fontSize: 13, color: '#334155' }}>
              Téléphone
              <input
                value={tel}
                onChange={(e) => setTel(e.target.value)}
                type="tel"
                required
                placeholder="Ex: 77 123 45 67"
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <label style={{ fontWeight: 700, fontSize: 13, color: '#334155' }}>
              Mot de passe
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                required
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <label style={{ fontWeight: 700, fontSize: 13, color: '#334155' }}>
              Confirmer le mot de passe
              <input
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                type="password"
                required
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <button type="submit" style={{ marginTop: 8, padding: '14px 16px', borderRadius: 14, border: 'none', cursor: 'pointer', fontWeight: 900, color: 'white', background: BRAND.gradient, boxShadow: '0 6px 20px rgba(79,70,229,0.25)', fontFamily: 'inherit' }}>
              Créer mon compte
            </button>
          </form>

          <div style={{ marginTop: 16, fontSize: 13, color: '#64748b' }}>
            Déjà un compte ?{' '}
            <Link to="/login" style={{ color: BRAND.primary, fontWeight: 800, textDecoration: 'none' }}>Se connecter</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
